export enum BackgroundTasksStatus {
  Processing = 'Processing',
  Failed = 'Failed',
  Completed = 'Completed',
}
